export const enum SurveysReportGeneratorFilterKey {
  SURVEY_GROUP = 'surveyGroupId',
  CLASSIFIED_OPEN_ENDED_GENERIC_QUESTION = 'classifiedOpenEndedGenericQuestion',
  CYCLES = 'surveysCycles',
  DIVISION = 'division',
  DIVISION_SIBLINGS_OR_CHILDREN_TOGGLE = 'displayDivisionSiblings',
  OVERRIDE_COLORS_MAPPING = 'overrideColorsMapping',
  SERVICES_BAR_CHART_ROW_TO_DISPLAY = 'servicesBarChartRowToDisplay',
  WORD_CLOUD_GENERIC_QUESTION_SELECT = 'wordCloudGenericQuestionSelect',
  WORD_CLOUD_SHOW_QUESTION_TEXT = 'wordCloudShowQuestionText',
  QUESTIONNAIRE_SURVEY_SINGLE_SELECT = 'questionnaireSurveySingleSelect',
  QUESTIONNAIRE_ASPECTS_SELECT = 'questionnaireAspectsSelect',
  QUESTIONNAIRE_TABLE_SPLIT_POSITION = 'questionnaireTableSplitPosition',
  QUESTIONNAIRE_TABLE_TO_DISPLAY = 'questionnaireTableToDisplay',
  DEMOGRAPHICS_TABLE_ROWS_PER_TABLE = 'demographicsTableRowsPerTable',
  MAINTAIN_AND_FOCUS_FILTERS = 'maintainAndFocusFilters',
  TOPICS_BUBBLE_CHART_SCALE_SELECT = 'topicsBubbleChartFiltersScaleSelect',
  TOPICS_BUBBLE_CHART_SENTIMENT_SELECT = 'topicsBubbleChartFiltersSentimentSelect',
  CROSS_TABS_FILTERS = 'crossTabsFilters',
  SERVICE_SENTIMENT_BAR_QUESTION_SELECT = 'serviceSentimentBar',
  CHOICES_QUESTION_CHART_DISPLAY_TYPE = 'choicesQuestionChartDisplayType',
  CHOICES_QUESTION_CHART_QUESTION_SELECT = 'choicesQuestionChartQuestionSelect',
  CHOICES_QUESTION_CHART_ORDER_BY = 'choicesQuestionChartOrderBy',
  BENCHMARK_ASPECT_SELECT = 'benchmarkAspectsSelect',
  SELECTED_SERVICE_BAR_ASPECTS = 'selectedServiceBarAspects',
  SERVICES_BAR_CHART_NUM_BARS_PER_ROW = 'servicesBarChartNumRowsPerTable',
  SERVICES_BAR_CHART_TABLE_TO_DISPLAY = 'servicesBarChartTableToDisplay',
}

export const enum SurveysReportGeneratorDataItemKey {
  CLASSIFICATION_TOP_CONCERNS_BY_AREA = 'classification-top-concerns-by-area',
  CLASSIFICATION_TOP_3_CONCERNS_BREAKDOWN = 'classification-top-3-concerns-breakdown',
  CLASSIFICATION_TOP_CONCERNS = 'classification-top-concerns',
  OVERALL_SATISFACTION_TEXT = 'overall-satisfaction-text',
  OVERALL_SATISFACTION_CHART = 'overall-satisfaction-chart',
  SENTIMENT_BAR_OVERALL_TABLE = 'sentiment-bar-overall-table',
  WORD_CLOUD = 'word-cloud',
  AREAS_SENTIMENT_TABLE = 'areas-sentiment-table',
  QUESTIONNAIRE = 'questionnaire',
  TOPICS_BUBBLE_CHART = 'topics-bubble-chart',
  SERVICES_BAR_CHART = 'services-bar-chart',
  DEMOGRAPHICS_TABLE = 'demographics-table',
  MAINTAIN_AND_FOCUS_BAR_CHARTS = 'maintain-and-focus-bar-charts',
  CROSS_TABS = 'cross-tabs',
  SERVICE_SENTIMENT_BAR = 'service-sentiment-bar',
  CHOICES_QUESTION_CHART = 'choices-question-chart',
  BENCHMARK_OVERALL_SATISFACTION = 'benchmark-overall-satisfaction',
  QUESTIONS_BENCHMARK_TABLE = 'questions-benchmark-table',
  BENCHMARK_TABLE_LEGEND = 'benchmark-table-legend',
  SCORES_OVER_TIME_BY_AREA = 'scores-over-time-by-area',
}

export const enum SurveysReportGeneratorBundleKey {
  OVERALL_BUNDLE = 'overall-bundle',
}
